export default function extSozVsgCalcSZ(bruttoGehalt) {
  const sozialversicherungsKlassen = [
    { min: 0, max: 518.44, satz: 0 },
    { min: 518.45, max: 1951, satz: 0.1412 },
    { min: 1951.01, max: 2128, satz: 0.1512 },
    { min: 2128.01, max: 2306, satz: 0.1612 },
    { min: 2306.01, max: 12120, satz: 0.1707 },
  ];

  let sVsgBeitrag = 0;
  let sVsgSatz = 0;

  for (let i = 0; i < sozialversicherungsKlassen.length; i++) {
    const klasse = sozialversicherungsKlassen[i];

    if (bruttoGehalt >= klasse.min && bruttoGehalt <= klasse.max) {
      sVsgBeitrag = klasse.satz * bruttoGehalt;
      sVsgSatz = klasse.satz * 100;
      break;
    } else if (bruttoGehalt > klasse.max) {
      sVsgBeitrag = klasse.satz * klasse.max;
      sVsgSatz = klasse.satz * 100;
    }
  }

  return { sVsgBeitrag, sVsgSatz };
}
